export const sortingSelectOptions = [
	{ label: 'Datum změny - vzestupně', value: 'Datum změny - vzestupně' },
	{ label: 'Datum změny - sestupně', value: 'Datum změny - sestupně' },
];

export const SORT_ASCENDING = 'asc';
export const SORT_DESCENDING = 'desc';
